<template>
    <div class="jjxq">
        <div class="jjxqcontent" v-cloak>
            <div class="zi">
                <span class="style1">{{dataobj.partyBranchName}}</span>
                <span>地址：{{dataobj.address}}</span>
                <van-swipe  class="lb" >
                    <van-swipe-item v-for="(i,idx) in dataobj.imgs" :key="idx"><img :src="'https://zhwy.zjj.suqian.gov.cn'+i" alt=""  @click="showimg()"></van-swipe-item>
                    <template #indicator>
                    </template>
                </van-swipe>
				<div @click="changeview('/hsyw/zbdy',dataobj.ids)" style="color: #00b5ff;font-size: 14px;" v-show="dataobj.ids!='0'">查看党员清单</div>
            </div>
        </div>
    </div>
</template>
<script>
import {
		mapState,
		mapMutations
	} from "vuex";
export default {
    data() {
        return {
           dataobj:{}
        }
    },
    mounted() {
       this.$axios.get('/api/v1/wygl/partybranch/view',{
		   params:{
			   houseId:sessionStorage.getItem('houseId'),
		   }
	   }).then(res=>{
            if(res.webUrl != '暂无照片'){
                res.imgs = res.webUrl.split(',')
            }
			this.dataobj=res;
		})
    },
	computed: {
		...mapState(['userInfo', 'identity', 'houseId']),
	},
    methods: {
        changeview(path,id) {
        	this.$router.push({
        		path,
        		query:{
        			id,
        		}
        	});
        },
        showimg(){
            var that = this
            ImagePreview({
                images: that.dataobj.imgs,
                closeable: true,
            });
        },
    },
}
</script>
<style lang="less" scoped>
[v-cloak]{
	display: none;
}
    .jjxq{
		background-color: #fff;
		padding: 10px;
		min-height: 100vh;
        .jjxqcontent{
            display: flex;
            flex-direction: column;
            img{
                width: 100%;
                height: 200px;
                border-radius: 10px;
            }
            .zi{
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                line-height: 30px;
                .style1{
                    color: #333333;
                    font-size: 18px;
                }
                span{
                    color: #999999;
                    font-size: 15px;
                }
            }
        }
    }
</style>